// src/components/OfficeOfRecord.js
//
// WO-001 phase S8 (2026-09-14, task list sections 225 and 246): "who held this office when this
// claim was acted on," on the claim record. Reads offices/{committee} and every officeTerms document
// for that office (both readable by any signed-in account - firestore.rules) and lets
// src\data\officeSuccession.js answer holderOn(officeId, filing date). It never invents a date: a term
// whose start is not on record says so, an office with no term says vacant or not of record.
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { holderLine, officeStateOn } from '../data/officeSuccession';

const C = { line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', bad: '#E06C6C', text: '#DCE7F2' };

export default function OfficeOfRecord({ committee, date, label }) {
  const [state, setState] = useState({ office: null, terms: null, err: '' });
  useEffect(() => {
    if (!committee) return undefined;
    let dead = false;
    (async () => {
      try {
        const [o, t] = await Promise.all([
          getDoc(doc(db, 'offices', committee)),
          getDocs(query(collection(db, 'officeTerms'), where('officeId', '==', committee))),
        ]);
        if (dead) return;
        setState({ office: o.exists() ? { officeId: committee, ...o.data() } : null, terms: t.docs.map(d => ({ termId: d.id, ...d.data() })), err: '' });
      } catch (e) { if (!dead) setState({ office: null, terms: [], err: 'Office record could not be read: ' + (e && e.code ? e.code : e.message) }); }
    })();
    return () => { dead = true; };
  }, [committee]);
  if (!committee) return null;
  // S8 (section 246): the same component now names the Local seat on the filing date too, so the fallback label follows the id's shape.
  const office = state.office || { officeId: committee, label: (/^LC/i.test(committee) ? 'Local Chairperson, ' : 'General Chairperson, ') + committee };
  const st = state.terms ? officeStateOn(office, state.terms, date) : null;
  return (
    <div style={{ fontSize: 12, color: C.dim, borderTop: '1px solid ' + C.line, paddingTop: 8, marginTop: 8 }}>
      <span style={{ textTransform: 'uppercase', letterSpacing: 1, fontSize: 10 }}>{label || 'Office of record on the filing date'}</span>
      <div style={{ color: st && st.state === 'held' ? C.text : C.accent, marginTop: 2 }}>
        {state.err ? <span style={{ color: C.bad }}>&#9888; {state.err}</span>
          : state.terms === null ? 'Loading…'
          : holderLine(office, state.terms, date)}
      </div>
      {!state.office && state.terms !== null && !state.err ? <div style={{ fontSize: 11, marginTop: 2 }}>No offices/{committee} document is seeded yet (scripts\seed-offices.js).</div> : null}
    </div>
  );
}
